import script from "./AdminRecordings.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminRecordings.vue?vue&type=script&setup=true&lang=js"

import "./AdminRecordings.vue?vue&type=style&index=0&id=934bb980&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-934bb980"]])

export default __exports__